import type { FaireProductEntity } from "../../entity_types/product";

export const p_fhxz4b6g5k: FaireProductEntity = {
  token: "p_fhxz4b6g5k",
  type: "product",
  name: "Toddler Hoodie, Zip Up Hooded Toddler Sweatshirt for Boys & Girls",
  brandToken: "b_h6twg7gbrb",
  brandName: "Mini Wardrobes",
  imageUrl:
    "https://cdn.faire.com/fastly/ae2756a01ee2555d94d33e610648ff08cd67147c051ab1f413ab8c2a3171e86d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95cb3ea912c11c7d6c77da1952fc9a9e8df49fd4d4213e0711f1494a4369170f.jpeg",
    "https://cdn.faire.com/fastly/ed1e16d72dd399db230499855ae90084424e770c8783a5c2b1051f0b168f9e9c.jpeg",
    "https://cdn.faire.com/fastly/2db6d9e9beef21f5ab3183b3127623025ae2e46ac89837dd7d81abc20d84d83c.jpeg",
    "https://cdn.faire.com/fastly/a1edc2d03f1a042ba73a2f2abd5d5d90ff469a73eafa6c311e54c89b4b8c159b.jpeg",
    "https://cdn.faire.com/fastly/1f618e8a84da04a04fc49ec0db7acc26554d46bf68ec7906ca61a41d1018bbad.jpeg",
  ],
  priceDollars: 8.92,
  description:
    "\nKeep your little one warm and stylish with our Color Block Toddler Hoodie! This zip up hooded sweatshirt is perfect for boys and girls, available in multiple colors and sizes 2T-7 years.\n\n· Stylish Colors: Available in Navy Grey, White Yellow, and Black Yellow.\n· Soft Fleece Cotton: Ensures comfort and warmth for your child.\n· Easy to Wear: The zip up design makes dressing quick and easy.\n· Versatile Style: Suitable for both boys and girls, perfect for everyday wear.\n· Durable Quality: Built to last through all your toddler’s adventures.\n",
  tags: [],
  msrpDollars: 18,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:42.311Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
